import { Typography } from 'antd'
import { type TextProps as AntdTextProps } from 'antd/lib/typography/Text'
import { clsx } from 'clsx'
import styles from './styles.module.scss'

export interface TextProps extends AntdTextProps {
  noMargin?: boolean
  textAlign?: React.CSSProperties['textAlign']
}

export function Text({ noMargin, textAlign, className, ...props }: TextProps) {
  return (
    <Typography.Text
      {...props}
      style={{ textAlign, ...props.style }}
      className={clsx(className, { [styles.noMargin]: noMargin })}
    />
  )
}
